module.exports = __webpack_public_path__ + "img/icon-arrow-next.d57c751e.svg";